import React from 'react'
import styled from 'styled-components'
import { useWindowSize } from '@/lib/use-hooks/use-window-size'
import { Animation, Reveal } from 'react-genie'
import LazyLoad from 'react-lazyload'
import { useCurrentLanguage } from '@/lib/current-language'
import { createResource, useResource } from '@/lib/i18n'
import { formatTimestamp } from '@/lib/utils'

const resource = createResource({
  en: {
    lastUpdate: `Last updated on `,
  },
  id: {
    lastUpdate: `Terakhir diperbarui pada `,
  },
})

const RateHook = (props) => {
  const { width } = useWindowSize()
  const { t } = useResource(resource)
  const { language: lng } = useCurrentLanguage()
  const rateList1 = lng === 'id' ? props.rateList['id'] : props.rateList['en']
  const rateList = []
  const rateListLeft = []
  const rateListRight = []
  for (const key in rateList1) {
    rateList.push(rateList1[key])
  }
  rateList.forEach((item, index) => {
    if (index < 5) {
      rateListLeft.push(item)
    } else {
      rateListRight.push(item)
    }
  })
  const formatTimeHandle = () => {
    const times = new Date()
    const day = times.getDate()
    const months = times.getMonth()
    const year = times.getFullYear()
    return `${10}/${day < 10 ? months : months + 1}/${year}`
  }

  return (
    <BannerBox>
      <div className="container">
        <div className="column">
          {rateListLeft.map((item, index) => {
            return (
              <div key={index} className="item">
                <LazyLoad>
                  <img className="item-img" src={item.imgurl} alt="item-icon" />
                </LazyLoad>
                <div className="item-title">{item.title}</div>
                <div className="item-rate">
                  {index < 3 && <div className="unit">Rp</div>}
                  <div className="rate">{item.rate}</div>
                </div>
              </div>
            )
          })}
        </div>
        <div className="column">
          {rateListRight.map((item, index) => {
            return (
              <div key={index} className="item">
                <LazyLoad>
                  <img className="item-img" src={item.imgurl} alt="item-icon" />
                </LazyLoad>
                <div className="item-title">{item.title}</div>
                <div className="item-rate">
                  <div className="rate">{item.rate}</div>
                </div>
              </div>
            )
          })}
          <div className="last-updated">{t('lastUpdate') + formatTimeHandle()}</div>
        </div>
      </div>
    </BannerBox>
  )
}

export default RateHook

const BannerBox = styled.div`
  @media only screen and (max-width: 1000px) {
    margin-top: 57px;
    min-height: 520px;
    .container {
      width: 100%;
      padding: 0 24px;
      .column {
        .item {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 40px;
          margin-bottom: 16px;
          border-radius: 8px;
          border: 1px solid #c2c2c2;
          .item-img {
            margin: 0 8px;
            width: 24px;
            height: 24px;
          }
          .item-title {
            font-size: 10px;
            font-family: Roboto-Medium, Roboto;
            font-weight: 500;
            color: #757575;
          }
          .item-rate {
            margin-left: auto;
            margin-right: 8px;
            color: #1cc812;
            display: flex;
            justify-content: center;
            align-items: center;
            .unit {
              font-size: 10px;
              font-family: Roboto-Regular, Roboto;
              font-weight: 400;
              padding-right: 2px;
            }
            .rate {
              font-size: 12px;
              font-family: Roboto-Medium, Roboto;
              font-weight: 500;
            }
          }
        }
        .last-updated {
          margin-top: 16px;
          font-size: 12px;
          font-family: Roboto-Regular, Roboto;
          font-weight: 500;
          color: #1cc812;
        }
      }
    }
  }
  @media only screen and (min-width: 1000px) {
    max-width: 1140px;
    margin: 90px auto 10px;
    .container {
      width: 100%;
      display: inline-flex;
      justify-content: space-between;
      align-items: top;
      .column {
        width: 510px;
        .item {
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          height: 56px;
          margin-top: 24px;
          border-radius: 8px;
          border: 1px solid #c2c2c2;
          .item-img {
            margin: 0 12px;
            width: 40px;
            height: 40px;
          }
          .item-title {
            font-size: 16px;
            font-family: Roboto-Medium, Roboto;
            font-weight: 500;
            color: #757575;
          }
          .item-rate {
            margin-left: auto;
            margin-right: 16px;
            color: #1cc812;
            display: flex;
            justify-content: center;
            align-items: center;
            .unit {
              font-size: 16px;
              font-family: Roboto-Regular, Roboto;
              font-weight: 400;
              padding-right: 2px;
            }
            .rate {
              font-size: 32px;
              font-family: Roboto-Medium, Roboto;
              font-weight: 500;
            }
          }
        }
        .last-updated {
          margin-top: 24px;
          font-size: 16px;
          font-family: Roboto-Regular;
          font-weight: 500;
          color: #1cc812;
        }
      }
    }
  }
`
